import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const interestService = {
  getAllInterest,
  addInterest,
  getInterest,
  deleteInterest,
  getInstructorInterest
};

function getAllInterest(params) {
  return apiCall("GET", apiUrls.interests.base, null, params);
}

function addInterest(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.interests.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getInterest(id) {
  return apiCall("GET", `${apiUrls.interests.base}/${id}`);
}

function deleteInterest(id) {
  return apiCall("DELETE", `${apiUrls.interests.base}/${id}`);
}

function getInstructorInterest(params) {
  return apiCall("GET", apiUrls.interests.instructor, null, params);
}
